import { SHOW_ALERT, HIDE_ALERT, HIDE_MODAL_ALERT } from "../types"

const initialState = {
	alert: null,
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case SHOW_ALERT:
		case HIDE_ALERT:
			return {
				...state,
				alert: action.payload,
			}

		case HIDE_ALERT:
			if (state.alert.type === "modal") {
				return {
					...state,
					alert: action.payload,
				}
			} else {
				return {
					...state,
				}
			}

		default:
			return state
	}
}
